import { useCallback, useEffect, useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";

export const DOCUMENT_LIBRARY_LIST_QUERY_KEY = "allDocumentsList";

/**
 * Schedules a single document-library list refresh after the drawer closes,
 * so the grid does not reorder while the user is still viewing the drawer.
 */
export function useDeferredDocumentLibraryRefresh(isDrawerOpen) {
  const queryClient = useQueryClient();
  const pendingRefreshRef = useRef(false);

  const scheduleLibraryRefresh = useCallback(() => {
    pendingRefreshRef.current = true;
  }, []);

  useEffect(() => {
    if (isDrawerOpen || !pendingRefreshRef.current) return;

    pendingRefreshRef.current = false;
    queryClient.invalidateQueries({ queryKey: [DOCUMENT_LIBRARY_LIST_QUERY_KEY] });
  }, [isDrawerOpen, queryClient]);

  return scheduleLibraryRefresh;
}

export default useDeferredDocumentLibraryRefresh;
